import React from 'react';
import {PathUtility} from 'src/shared/constants/PathBuilder';

import type {
  SafetyEventSimpleResponse} from 'src/api/ProactApiClient';
import {
  FeatureFlagEnum,
  ModuleEnum,
  PermissionOperationEnum
} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {PageHeader} from 'src/design/organisms/PageHeader';
import {TableToolbar} from 'src/design/molecules/TableToolbar';
import {PermissionGuard} from 'src/app/security/authorization/PermissionGuard';

import {SidebarLinkSafetyEvents} from 'src/app/layout/Sidebar/SidebarLinksConfig';
import {SafetyEventTable} from 'src/app/safety-events/SafetyEventTable/SafetyEventTable';
import {routeRegistry} from 'src/pages/RouteRegistry';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';
import {SafetyEventDocumentTitle} from 'src/app/safety-events/safetyEventHelpers';
import {useAppNavigate} from 'src/shared/hooks/useAppNavigate';

export const SafetyEventListPage: React.FC = () => {
  useSetDocumentTitle(SafetyEventDocumentTitle);
  const navigate = useAppNavigate();

  const handleAddNew = () => navigate(PathUtility.SafetyEventCreate());

  const handleNavigateTo = (row: SafetyEventSimpleResponse) =>
    navigate(PathUtility.SafetyEventView(String(row.id), 'content'));

  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.SafetyEvents}>
      <PageHeader>
        <PageHeader.Title
          icon={SidebarLinkSafetyEvents.icon}
          subtitle="Track and manage safety incidents">
          Safety Events
        </PageHeader.Title>
      </PageHeader>
      <SafetyEventTable
        identifier={'safety-event-table'}
        onViewRowClick={handleNavigateTo}
        actionBarPreNode={
          <PermissionGuard
            module={ModuleEnum.SafetyEvent}
            operation={PermissionOperationEnum.Create}>
            <TableToolbar.Action variant="create" onClick={handleAddNew}>
              New Safety Event
            </TableToolbar.Action>
          </PermissionGuard>
        }
      />
    </ContentWrapper>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.SafetyEvent(),
  element: <SafetyEventListPage />,
  module: ModuleEnum.SafetyEvent,
  operation: PermissionOperationEnum.View,
  isPrivate: true,
});

